module.exports = __webpack_public_path__ + "img/flavor10.49a72913.png";